import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View } from 'foundations-components/components/View';
import { Select } from 'foundations-components/transitional/components/Select';
import debounce from 'hs-lodash/debounce';
import BuyerOverridesActionTypes from '../state/BuyerOverrides/actionTypes';
import noop from 'hs-lodash/noop';
import I18n from 'I18n';
import { usePaymentFormContext } from '../context/PaymentFormContext';
import { getLineItemBlurByLineItemId, setLineItemBlur } from '../state/lineItemBlursSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_DELAY = 200;
export const createQuantityOptions = (min, max, quantity, selected = false) => {
  if (!min || !max || min > max) return [];
  const opts = Array(max - min + 1).fill(0).map((_, i) => i + min).map(n => ({
    text: n.toString(),
    value: n,
    key: n,
    ['data-test-id']: `custom-quantity-input-option-${n}`
  }));
  if (selected) {
    const removeOption = {
      text: I18n.text('payments.lineItemOptionalRemoveOption'),
      value: '0',
      key: '0',
      ['data-test-id']: 'custom-quantity-input-option-0'
    };
    return [removeOption, ...(min === 0 ? opts.slice(1) : opts)];
  }
  return opts;
};
export default function CustomQuantitySelect({
  id,
  quantity: initialQuantity,
  min,
  max,
  error,
  selected,
  toggleSelected = noop
}) {
  const [quantity, setQuantity] = useState(initialQuantity);
  const dispatch = useDispatch();
  const {
    formState
  } = usePaymentFormContext();
  const isCheckoutSubmitPending = formState.get('isCheckoutSubmitPending');
  const isBlurred = useSelector(state => getLineItemBlurByLineItemId(state, id));
  const debouncedHandleOnChange = debounce(event => {
    if (selected && event.target.value === '0') {
      toggleSelected();
    }
    dispatch({
      type: BuyerOverridesActionTypes.SET_QUANTITY,
      data: {
        id,
        quantity: Number(event.target.value)
      }
    });
  }, DEBOUNCE_DELAY);
  const onChange = event => {
    setQuantity(Number(event.target.value));
    debouncedHandleOnChange(event);
  };
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "200",
    borderBlockEndColor: "border-interactive-pressed",
    marginInlineStart: "200",
    marginBlockEnd: "100",
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "custom-quantity-input",
      disabled: isCheckoutSubmitPending,
      onOpenChange: isOpen => {
        if (!isOpen) {
          dispatch(setLineItemBlur({
            lineItemId: id,
            isBlurred: true
          }));
        }
      },
      error: error && isBlurred,
      onChange: onChange,
      options: createQuantityOptions(min, max, quantity, selected),
      value: quantity.toString(),
      searchable: false,
      buttonUse: "primary-white",
      textAlign: "right"
    })
  });
}